import base from '../base';
import {
  getRequest,
  postJsonRequest,
  postRequest
} from '@/util/http';

// 结算规则下拉
export function subjectType(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/subject_type_query`, params)
}

// 对公对私账户查询银行名
export function accountTypeQuery(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/account_type_query`, params)
}

// 根据市模糊查询
export function provinceCityQuery(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/province_city_query`, params)
}

// 根据市模糊查询
export function settlementRulesIdQuery(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/settlement_rules_id_query`, params)
}

//各资料模块下一步保存
export function saveEditDraft(params) {
  return postJsonRequest(`${base.baseUrl}/merchantPurchase/save_edit_draft`, params)
}

// 首页列表
export function listData(params) {
  return postJsonRequest(`${base.baseUrl}/merchantPurchase/list_query`, params)
}

// 编辑回显
export function draftEcho(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/draft_echo`, params)
}

// 提交
export function submit(params) {
  return postJsonRequest(`${base.baseUrl}/merchantPurchase/submit_application`, params)
}
//省份
export function provinceList(params) {
  return getRequest(`${base.baseUrl}/manage/dic/findProvinceList`, params)
}
//市
export function cityList(params) {
  return getRequest(`${base.baseUrl}/manage/dic/findCityList`, params)
}

//其他银行
export function otherBank(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/other_bank`, params)
}

//服务商列表
export function merchantList(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/query_goods`, params)
}
//首页状态数值
export function statusNum(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/status_return`, params)
}

//图片转mediaId
export function mediaId(params) {
  return postRequest(`${base.baseUrl}/merchantPurchase/change_media_id`, params)
}

// 查看进度
export function queryApplication(params) {
  return getRequest(`${base.baseUrl}/merchantPurchase/query_application`, params)
}